<template>
  <div class="date-select">
    <div class="wrap">
      <div class="content-inner">
        <div class="ht">
          请选择时间
        </div>
        <div class="body">
          <select v-model="selected[0]">
            <option
              v-for="(item, index) in year"
              :key="'key-year-'+index"
              :value="item"
            >
              {{ item }}
            </option>
          </select> <span>年</span>
          <select v-model="selected[1]">
            <option
              v-for="item in mon"
              :key="'key-mon-'+item"
              :value="item"
            >
              {{ item }}
            </option>
          </select><span>月</span>
          <select v-model="selected[2]">
            <option
              v-for="item in day"
              :key="'key-day-'+item"
              :value="item"
            >
              {{ item }}
            </option>
          </select><span>日</span>
        </div>
        <div class="foot">
          <div
            class="btn btn-primary"
            @click="click"
          >
            设置
          </div>
          <div
            class="btn btn-default"
            @click="close"
          >
            关闭
          </div>
        </div>
      </div>
    </div>
    <div
      class="mask"
      @click="close"
    />
  </div>
</template>
<style lang="stylus">
.date-select
  position fixed
  left 0
  right 0
  bottom 0
  top 0
  z-index 1000
  transition all 0.4s ease-in
  &.slide-down-enter-active
    .mask
      animation fadeIn 0.3s ease both
    .wrap
      animation fadeInDown 0.3s ease 0.1s both
  &.slide-down-leave-active
    .mask
      animation fadeOut 0.3s ease both
    .wrap
      animation fadeOutUp 0.3s ease both
  .wrap
    position relative
    z-index 1100
    background #fff
    width 95%
    margin 2rem auto 0
    border-radius 0.06rem
    .content-inner
      position relative
      .ht
        padding 0.3rem 0.3rem 0.15rem
        font-size 0.36rem
        font-weight bold
        text-align center
        color #555
      .body
        margin 0.2rem 0.1rem 0.5rem
        font-size 0.26rem
        color #808080
        text-align center
        select
          border none
          border-bottom solid 1px #ccc
          appearance none
          -moz-appearance none
          -webkit-appearance none
          // padding 0.03rem 0.1rem
          background none
          font-size 0.42rem
          text-align center
          cursor pointer
          border-radius 0
        select::-ms-expand
          display none
        span
          margin-right 0.2rem
          padding-left 0.05rem
          &:last-child
            margin-right 0
      .foot
        padding 0.2rem 0.3rem
        background #f7f7f7
        border-top 1px solid #ededed
        border-radius 0 0 0.06rem 0.06rem
        text-align center
        .btn
          margin 0 0.05rem
          padding-left 0.3rem
          padding-right 0.3rem
  .mask
    position fixed
    left 0
    right 0
    bottom 0
    top 0
    z-index 1000
    background rgba(0, 0, 0, 0.5)
</style>

<script>
import moment from 'dayjs'
export default {
  components: {
  },
  props: {
    value: Object,
    max: {
      type: Number,
      default: moment().year() + 20
    },
    min: {
      type: Number,
      default: moment().year() - 100
    }
  },
  data () {
    return {
      year: [],
      mon: 12,
      day: 31,
      selected: ''
    }
  },
  watch: {
    selected (val, oldval) {
      const m = val[0] + '-' + val[1]
      const day = moment(m, 'YYYY-MM').daysInMonth()
      if (val[2] > day) {
        this.selected[2] = 1
      }
      this.day = day
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    close () {
      let value = this.value
      value.show = false
      this.$emit('input', value)
    },
    click () {
      let value = this.value
      value.selected = this.selected.join('-')
      value.show = false
      this.$emit('input', value)
      this.$emit('submit', value.selected)
    },
    init () {
      const m = moment()
      this.selected = [m.year(), m.month() + 1, m.date()]
      for (let i = this.max; i >= this.min; i--) {
        this.year.push(i)
      }
    }
  }
}
</script>
